import {
  Box,
  FloraButton,
  Flex,
  Grid,
  FloraInput,
  FloraTypography,
  FloraSelect,
  FloraSelectItem
} from '@grupoboticario/flora-react'

import { BackofficeImage } from '@/components/BackofficeImage/BackofficeImage'
import { EVENT_TYPES } from '@/constants/benefitIds'
import { DEFAULT_CPF_LIMITS } from '@/constants/eventFormDefaults'

import * as S from './EventDayItem.styles'
import { EventDayItemProps } from './EventDayItem.types'

const EventDayItem = ({ dia, index, eventType, onUpdate, onDelete, canDelete }: EventDayItemProps) => {
  const currentLimit = dia.limitPerCpf ? Number.parseInt(dia.limitPerCpf, 10) : null
  const rescueTicketLimitByUser =
    currentLimit && !DEFAULT_CPF_LIMITS.includes(currentLimit)
      ? [...DEFAULT_CPF_LIMITS, currentLimit].sort((a, b) => a - b)
      : DEFAULT_CPF_LIMITS

  return (
    <Box css={S.dayItemBoxCss}>
      <Flex align="center" css={S.dayHeaderCss} justify="space-between">
        <FloraTypography fontSize="bodySmallStandard" fontWeight="medium">
          Dia {index + 1}
        </FloraTypography>
      </Flex>

      <Flex direction="column" gap="$4">
        <Grid css={S.dateGridCss}>
          <FloraInput
            id={`data-${index}`}
            label="Data:"
            onChange={(e) => {
              e.preventDefault()
              e.stopPropagation()
              onUpdate(index, 'date', e.target.value)
            }}
            required
            size="medium"
            type="date"
            value={dia.date}
          />
          <FloraInput
            id={`horaInicio-${index}`}
            label="Hora início:"
            onChange={(e) => {
              e.preventDefault()
              onUpdate(index, 'startTime', e.target.value)
            }}
            required
            size="medium"
            type="time"
            value={dia.startTime}
          />
          <FloraInput
            id={`horaFim-${index}`}
            label="Hora fim:"
            onChange={(e) => {
              e.preventDefault()
              onUpdate(index, 'endTime', e.target.value)
            }}
            required
            size="medium"
            type="time"
            value={dia.endTime}
          />
        </Grid>

        <Grid css={S.ticketGridCss(eventType === EVENT_TYPES.FACTORY_VISIT)}>
          <FloraInput
            id={`qtdIngressos-${index}`}
            label="Quantidade de ingressos:"
            mask="xxxxxxxx"
            onChange={(e) => {
              e.preventDefault()
              onUpdate(index, 'ticketQuantity', e.target.value)
            }}
            required
            size="medium"
            value={dia.ticketQuantity}
          />
          {eventType !== EVENT_TYPES.FACTORY_VISIT && (
            <Box>
              <FloraSelect
                id={`limiteCPF-${index}`}
                aria-label="Limite por CPF:"
                label={!dia.limitPerCpf ? 'Limite por CPF:' : ''}
                onSelected={(selected) => onUpdate(index, 'limitPerCpf', selected?.value ?? '')}
                value={dia.limitPerCpf || ''}
                required
                size="medium"
              >
                {rescueTicketLimitByUser.map((limit) => (
                  <FloraSelectItem key={limit} label={String(limit)} value={String(limit)} />
                ))}
              </FloraSelect>
            </Box>
          )}
        </Grid>
      </Flex>

      <FloraButton
        css={S.deleteBorderlessCss}
        disabled={!canDelete}
        onClick={() => onDelete(index)}
        type="button"
        has="iconLeft"
        icon={<Box as={BackofficeImage} alt="" aria-hidden height={20} src="/img/trash.svg" width={20} />}
      >
        Excluir dia
      </FloraButton>
    </Box>
  )
}

export default EventDayItem
